import React, { useState } from "react";
import { Autocomplete } from "@react-google-maps/api";

const AddressAutoComplete = ({ onPlaceSelected, placeholder = 'Enter a location', val}) => {
    const [autocomplete, setAutocomplete] = useState(null);
    const [inputValue, setInputValue] = useState(val || "");

    const handleLoad = (autocompleteInstance) => {
        setAutocomplete(autocompleteInstance);
    };

    const handlePlaceChanged = () => {
        if (autocomplete) {
            const place = autocomplete.getPlace();
            if (place.geometry) {
                const location = {
                    address: place.formatted_address.includes(place.name) ? place.formatted_address : place.name + ' , ' + place.formatted_address,
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng(),
                };
                onPlaceSelected(location);
                setInputValue(location.address); // Update input with selected address
            }
        }
    };

    return (
        <Autocomplete onLoad={handleLoad} onPlaceChanged={handlePlaceChanged}>
            <input
                type="text"
                placeholder={placeholder}
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    height: '37px',
                }}
            />
        </Autocomplete>
    );
};

export default AddressAutoComplete;
